import React from 'react';
import { FormattedDate, FormattedMessage } from 'react-intl';
export default function formatMessageWithDate(id, expirationDate) {
    var date = (React.createElement(FormattedDate, { value: expirationDate, month: "short", day: "numeric" }));
    return React.createElement(FormattedMessage, { id: id, defaultMessage: id, values: { date: date } });
}
